// extracted by mini-css-extract-plugin
export default {"features":"features_features__sINwM","featuresTitle":"features_featuresTitle__69yJk","description":"features_description__2fuJT","cardsContainer":"features_cardsContainer__rGNaC"};